<template>
	<v-card>
		<v-card-text>
			<v-form ref="formAntecedentes">
				<v-simple-table dense class="no-bordes">
					<tbody>
						<template
							v-for="(antecedente, i) in valor.Antecedentes"
						>
							<tr :key="i" class="pb-3">
								<td>{{ antecedente.Nombre }}</td>
								<td>
									<v-radio-group
										class="ma-3"
										row
										hide-details="auto"
										mandatory
										v-model="antecedente.Presencia"
									>
										<v-radio
											label="Sí"
											:value="true"
											hide-details="auto"
										></v-radio>
										<v-radio
											hide-details="auto"
											label="No"
											:value="false"
										></v-radio>
									</v-radio-group>
								</td>
								<td width="25%">
									<v-text-field
										v-if="antecedente.Presencia"
										required
										:rules="[
											!!antecedente.FrecuenciaConsumo ||
												'Campo Obligatorio'
										]"
										:label="
											antecedente.AntecedenteID === 2
												? 'Número de cajetillas o cigarrillos'
												: 'Frecuencia de consumo'
										"
										v-model="antecedente.FrecuenciaConsumo"
										hide-details="auto"
									>
									</v-text-field>
								</td>
								<td width="25%">
									<v-text-field
										:rules="[
											!!antecedente.TiempoConsumo ||
												'Campo Obligatorio'
										]"
										v-if="antecedente.Presencia"
										label="Tiempo de consumo"
										v-model="antecedente.TiempoConsumo"
										hide-details="auto"
									>
									</v-text-field>
								</td>
							</tr>
						</template>
					</tbody>
				</v-simple-table>
			</v-form>
			<v-layout row mt-3>
				<v-flex xs6>
					<v-btn color="primary" @click.prevent="anterior">
						<v-icon>arrow_back_ios</v-icon> ANTERIOR
					</v-btn>
				</v-flex>
				<v-flex xs6 class="text-right">
					<v-btn color="primary" @click.prevent="guardar">
						<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
					</v-btn>
				</v-flex>
			</v-layout>
		</v-card-text>
	</v-card>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	props: ["datos"],
	name: "antNoPatologicos",
	data() {
		return {
			valor: {
				Antecedentes: [
					{
						AntecedenteID: 1,
						Nombre: "Alcohol",
						Presencia: false,
						FrecuenciaConsumo: "",
						TiempoConsumo: ""
					},
					{
						AntecedenteID: 2,
						Nombre: "Tabaco",
						Presencia: false,
						FrecuenciaConsumo: "",
						TiempoConsumo: ""
					},
					{
						AntecedenteID: 3,
						Nombre: "Drogas",
						Presencia: false,
						FrecuenciaConsumo: "",
						TiempoConsumo: ""
					}
				]
			},
			catalogos: {}
		};
	},
	methods: {
		siguiente() {
			this.$emit("siguiente");
		},
		anterior() {
			this.$emit("anterior");
		},
		async guardar() {
			if (this.$refs.formAntecedentes.validate()) {
				const data = {
					HistoriaClinicaID: this.historiaCliniciaId,
					json: JSON.stringify(this.valor)
				};
				const res = await ServicioHistorialClinico.guardarAntecedentesNoPatologicos(
					data
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			}
		}
	},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	mounted() {},
	watch: {
		datos() {
			if (this.datos) {
				this.valor = JSON.parse(this.datos);
			}
		}
	}
};
</script>
